import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// axiosInstance.interceptors.request.use(
//   (config) => {
//     if (localStorage.getItem("user-omni")) {
//       const token = JSON.parse(localStorage.getItem("user-omni")).token;
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (err) => {
//     return Promise.reject(err);
//   }
// );

// axiosInstance.interceptors.response.use(
//   (response) => {
//     if (response.data.message === "Unauthorized") {
//       localStorage.removeItem("user-omni");
//       window.location.href = "/";
//     }
//     return response;
//   },
//   (err) => {
//     return Promise.reject(err);
//   }
// );

export default axiosInstance;
